import { compareRows } from "@/mocks/home";

export default function CompareBoard() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-site px-4 md:px-8">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.24em] text-primary-600">
              <i className="ri-scales-3-line text-sm"></i>
              SURFACE VS TRUTH
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              表象与真相对照
            </h2>
          </div>
          <p className="max-w-md text-sm leading-7 text-foreground-600">
            舆论场里最容易被传播的，往往不是最接近事实的那一层。把它和核对后的结论并排放，差距一目了然。
          </p>
        </div>

        <div className="mt-9 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="hidden grid-cols-12 gap-4 border-b border-background-200 bg-background-100 px-6 py-4 text-xs font-semibold tracking-wide text-foreground-600 md:grid">
            <span className="col-span-2">维度</span>
            <span className="col-span-5">舆论表象</span>
            <span className="col-span-5">核对后的真相</span>
          </div>

          {compareRows.map((row, i) => (
            <div
              key={row.dim}
              className={`grid grid-cols-1 gap-3 px-5 py-5 md:grid-cols-12 md:gap-4 md:px-6 ${
                i !== compareRows.length - 1 ? "border-b border-background-200" : ""
              }`}
            >
              <div className="md:col-span-2">
                <span className="rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-semibold text-secondary-900">
                  {row.dim}
                </span>
              </div>
              <div className="flex items-start gap-2.5 md:col-span-5">
                <i className="ri-close-circle-line mt-0.5 text-base text-foreground-400"></i>
                <p className="text-sm leading-7 text-foreground-600">{row.surface}</p>
              </div>
              <div className="flex items-start gap-2.5 md:col-span-5">
                <i className="ri-checkbox-circle-line mt-0.5 text-base text-primary-600"></i>
                <p className="text-sm leading-7 font-medium text-foreground-950">{row.truth}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}